<template>
	<div class="global-transaction">
		<ul class="results-list results-list--global-transaction" :id="uid">
			<li
				:id="`${uid}_list`"
				class="results-list__item"
				v-for="(item, index) in items"
				:key="index"
			>
				<GlobalTransactionsCard
					:id="`${uid}_${index}_transaction`"
					:transaction="item"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import GlobalTransactionsCard from './transactions-card';
export default {
	name: 'GlobalTransactionsList',
	components: {
		GlobalTransactionsCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>
